<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'
import { useI18n } from 'vue-i18n'
import PeopleIcon from '~icons/material-symbols/group-outline'

const { t } = useI18n()
const impersonateStore = useImpersonateStore()
const impersonate = useImpersonate()

const isMobile = ref(false)

function checkScreenSize() {
  isMobile.value = window.innerWidth < 640
}

onMounted(() => {
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkScreenSize)
})

const buttonText = computed(() => {
  return isMobile.value
    ? t('app.alert.partner.textButtonMobile')
    : t('app.alert.partner.textButton')
})

function viewAdmin() {
  impersonate.removeImpersonate()
}
</script>

<template>
  <div
    v-if="impersonateStore.showAlertImpersonateActive"
    class="view-partner-alert"
  >
    <div class="view-partner-alert-icon">
      <PeopleIcon class="icon" />
    </div>
    <div class="view-partner-alert-content">
      <div class="view-partner-alert-text">
        <span class="view-partner-alert-label">{{ t('app.alert.partner.viewing_as') }}:</span>
        <span class="view-partner-alert-name">{{ impersonateStore.fantasyName }}</span>
      </div>
    </div>
    <SolButton
      id="view-partner-action"
      class="view-partner-alert-button"
      size="small"
      variant="secondary"
      @click="viewAdmin"
    >
      {{ buttonText }}
    </SolButton>
  </div>
</template>

<style scoped lang="scss">
.view-partner-alert {
  @apply flex gap-4 items-center px-4 py-2 w-full;
  @apply bg-feedback-informative-light border-b border-feedback-informative-medium;

  &-icon {
    @apply flex items-center flex-shrink-0;

    .icon {
      @apply w-6 h-6 text-feedback-informative-pure;
    }
  }

  &-content {
    @apply flex-1 min-w-0;
  }

  &-text {
    @apply flex flex-col gap-1 leading-[1.15] not-italic;

    @screen sm:system {
      @apply flex-row items-center;
    }
  }

  &-label {
    @apply fonts-body-medium-regular text-feedback-informative-dark;
  }

  &-name {
    @apply fonts-body-medium-bold text-feedback-informative-dark;
  }

  &-button {
    @apply flex-shrink-0;
  }
}
</style>
